'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isNull(value) {
    return value === null;
}

exports.isNull = isNull;
